var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"magic-link ma-auto text-center pb-5"},[_c('iconMagicLink',{staticClass:"mt-4"}),_c('div',{staticClass:"text mt-4"},[_vm._v(_vm._s(_vm.$t('settings.magicLink.description')))]),_c('magic-link-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }